"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccess = void 0;
var tslib_1 = require("tslib");
var isBoolean_1 = tslib_1.__importDefault(require("lodash/isBoolean"));
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
var react_1 = require("react");
var context_1 = tslib_1.__importDefault(require("./context"));
function useAccess() {
    var access = react_1.useContext(context_1.default);
    return {
        access: access,
        hasAccess: function (accessName, params, ifNoMatch) {
            if (ifNoMatch === void 0) { ifNoMatch = true; }
            var hasAccess = true;
            if (access[accessName]) {
                var temp = access[accessName];
                if (isBoolean_1.default(temp)) {
                    hasAccess = temp;
                }
                if (isFunction_1.default(temp)) {
                    hasAccess = temp(params);
                }
            }
            return hasAccess;
        },
    };
}
exports.useAccess = useAccess;
